import { render } from "./ExperienceTab.vue?vue&type=template&id=097dc2c0&scoped=true"
import script from "./ExperienceTab.vue?vue&type=script&lang=js"
export * from "./ExperienceTab.vue?vue&type=script&lang=js"

import "./ExperienceTab.vue?vue&type=style&index=0&id=097dc2c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097dc2c0"]])

export default __exports__